export default __webpack_public_path__ + "static/media/fa.bundle.06190075.svg";